import React, { useState, useContext, useEffect,useMemo  } from 'react';
import { GlobalContext } from "../context/GlobalState";
import { Link, useHistory } from "react-router-dom";
import {
  Form,
  FormGroup,
  Label,
  Input,
  Button,
  Navbar,
  Nav,
  NavItem,
  NavbarBrand,
  Container
} from "reactstrap";
import axios from 'axios';
import Select from 'react-select'
import countryList from 'react-select-country-list'
export const EditUser = (props) => {
  const { editUser, users } = useContext(GlobalContext);
  const [selectedPackage, setselectedPackage] = useState({
    
  })
  const [trackingNo, setTRN] = useState();
  const [sender, setsender] = useState("");
  const [receiver, setreceiver] = useState("");
  const [dsc, setdsc] = useState("");
  const [iv, setiv] = useState("");
  const [sc, setsc] = useState();
  const [cc, setcc] = useState();
  const [sts, setsts] = useState("");
  const [tc, settc] = useState();
  const [qty, setqty] = useState();
  const [org, setorg] = useState("");
  const [dst, setdst] = useState("");
  const [prg, setprg] = useState();
  const [cl, setcl] = useState();
  const [phone, setphone] = useState();
  const [email, setemail] = useState();
  const [loading, setLoading] = useState();
  const [count, setcount] = useState();
  const history = useHistory();
  const [OC, setoc] = useState('')
  const[ins,setins]=useState()
 const[weight,setweight]=useState()
const[pm,setpm]=useState()
  const[ct,setct]=useState()
  const[dc,setdc]=useState()
 const[dte,setdte]=useState()
 const[ddate,setddate]=useState()
 const [sphone, setsphone] = useState();
 const [semail, setsemail] = useState();
 const[st,setst]=useState("AIR FREIGHT")
  const currentPackageId = props.match.params.id;
  const options = useMemo(() => countryList().getData(), [])
  const changeHandler = value => {
    setoc(value)
  }
  const changeHandler2 = value => {
    setdc(value)
  }
  const changeHandler3 = value => {
    setcl(value)
  }
  useEffect(() => {
    const fetchData = async () =>{
      setLoading(true);
      try {
        const {data: response} = await axios.get(`https://princetrack-f6ffc-default-rtdb.europe-west1.firebasedatabase.app/pkg2/${currentPackageId}/.json`);
       setst(response.shipmenttype)
        setTRN(response.trackingNumber)
        setsender(response.from)
        setreceiver(response.to)
        setdsc(response.description)
        setiv(response.value)
        setsc(response.Shippingcost)
       setdc(response.destinationcountry)
        setsts(response.status)
       setoc(response.origincountry)
        setqty(response.Quantity)
        setorg(response.origin)
        setdst(response.Destination)
        setprg(response.progress)
        setcl(response.currentlocation)
        setphone(response.phone)
        setemail(response.email)
        setsphone(response.senderphone)
        setsemail(response.senderemail)
setweight(response.weight)
setpm(response.Paymentmode)
setdte(response.date)
setddate(response.deliveryday)
setct(response.courier)
setins(response.insurance)
      } catch (error) {
        console.error(error.message);
      }
      setLoading(false);
    }

    fetchData();
    
       
    
   
  },[selectedPackage])

  

  const onSubmit = (e) => {
    e.preventDefault();
 const   packageToPatch= {
  trackingNumber: trackingNo,
  
from:sender,
to:receiver,
description:dsc,
value:iv,
email:email,
insurance:ins,
phone:phone,senderemail:semail,
senderphone:sphone,
currentlocation:cl,
Shippingcost:sc,
status:sts,
deliveryday:ddate,
clearancecost:cc,
totalcost:tc,
Quantity:qty,
product:"bag",
date:dte,
origin:org,
Destination:dst,
progress:prg,
weight:weight,
Paymentmode:pm,
courier:ct,
origincountry:OC,
destinationcountry:dc,
shipmenttype:st
  
}
    axios.patch(`https://princetrack-f6ffc-default-rtdb.europe-west1.firebasedatabase.app/pkg2/${currentPackageId}/.json`, packageToPatch).then(()=>{
      window.alert('updated succesffulyy');
      history.push("/admindash104")
      
          }).catch((error) => alert( error))
}

  return (
    <div style={{background:"teal"}}>
       <Navbar color="dark" dark >
      <Container>
        <NavbarBrand href="/">SWIFT WAY CARGO </NavbarBrand>
        <h3 style={{color:"white"}}>View/Edit Package</h3>
        <Nav>
          <NavItem>
            <Link className="btn btn-danger" to="/admindash104"> Back</Link>
          </NavItem>
        </Nav>

      </Container>
    </Navbar>
    <Form onSubmit={onSubmit} style={{ width:"100%",margin:"auto",}}
    
    
    >
      <div style={{display:"flex" ,gap:'10px',justifyContent:'space-evenly',width:"90vw",flexWrap:"wrap",}}>
        <FormGroup>
          <h1>PACKAGE INFORMATION</h1>
          <Label>Tracking No:</Label>
     <Input type="number" value={trackingNo} disabled onChange={(e)=>{
       setTRN(e.target.value)
     }} name="trackingNo" placeholder="Enter a unique 10 digit number" required></Input>
      <Label>description:</Label>
     <Input type="text" value={dsc} onChange={(e)=>{
       setdsc(e.target.value)
     }} name="dsc" placeholder="Enter description" required></Input>
     <Label>Weight:</Label>
     <Input type="number" value={weight} onChange={(e)=>{
       setweight(e.target.value)
     }} name="dsc" placeholder="Enter Weight in kg" required></Input>
     <Label>item value:</Label>
     <Input type="text" value={iv} onChange={(e)=>{
       setiv(e.target.value)
     }} name="sender" placeholder="Enter item value" required></Input>
      <Label>Insurance cost:</Label>
     <Input type="number" value={ins} onChange={(e)=>{
       setins(e.target.value)
     }} name="sc" placeholder="Enter insurance cost" required></Input>
     <Label>Shipping cost:</Label>
     <Input type="number" value={sc} onChange={(e)=>{
       setsc(e.target.value)
     }} name="sc" placeholder="Enter shipping cost" required></Input>
     <Label>Shipping date:</Label>
     <Input type="text" value={dte} onChange={(e)=>{
       setdte(e.target.value)
     }} name="sc" placeholder="Enter shipping date dd/mm/yyyy" required></Input>
      <Label>Expected delivery date:</Label>
     <Input type="text" value={ddate} onChange={(e)=>{
       setddate(e.target.value)
     }} name="sc" placeholder="Enter shipping date dd/mm/yyyy" required></Input>
      <Label>Payment Mode</Label>
     <br/>
     <select name="" onChange={(e)=>{setpm(e.target.value)}} required value={pm} id="">
       <option value="CASH">CASH</option>
       <option value="CHEQUE">CHEQUE</option>
       <option value="BACS">BACS</option>
       
     </select>
     <br/>
     <Label>Shipment Type</Label>
     <br/>
     <select name="" onChange={(e)=>{setst(e.target.value)}} required value={st} id="">
       <option value="AIR FREIGHT">AIR FREIGHT</option>
       <option value="INTERNATIONAL SHIPPING">INTERNATIONAL SHIPPING</option>
       <option value="TRUCKLOAD">TRUCKLOAD</option>
       <option value="VAN MOVE">VAN MOVE</option>
       
     </select>
     <br/>
     <br/>
      <Label>Courier Type:</Label>
     <br/>
     <select name="" onChange={(e)=>{setct(e.target.value)}} required value={ct} id="">
       <option value="FEDEX">FEDEX</option>
       <option value="USPS">USPS</option>
       <option value="DHL">DHL</option>
       
     </select>
     <br/>
     <Label>Status:</Label>
     <br/>
     <select name="" required onChange={(e)=>{setsts(e.target.value)}} value={sts} id="">
     <option value="ENROUTE">ENROUTE</option>
       <option value="PENDING">PENDING</option>
       <option value="ON HOLD">ON HOLD</option>
       <option value="RETURNED">RETURNED</option>
       <option value="OUT FOR DELIVERY">OUT FOR DELIVERY</option>
       <option value="PICKED UP">PICKED UP</option>
       <option value="DELIVERED">DELIVERED</option>
       <option value="IN TRANSIT">IN TRANSIT</option>
     </select>
     <br/>
     <Label>QTY:</Label>
     <Input type="text" value={qty} onChange={(e)=>{
       setqty(e.target.value)
     }} name="qty" placeholder="Enter Quantity" required></Input>
      <Label>progress:</Label>
     <Input type="number" value={prg} onChange={(e)=>{
       setprg(e.target.value)
     }} name="prg" placeholder="Enter percentage progress" required></Input>
        </FormGroup>
      <FormGroup>
     <h1>SENDER DETAILS</h1>
   
      <Label>Sender Name:</Label>
     <Input type="text" value={sender} onChange={(e)=>{
       setsender(e.target.value)
     }} name="sender" placeholder="Enter sender name" required></Input>
     
      <Label>Phone:</Label>
     <Input type="text" value={sphone} onChange={(e)=>{
       setsphone(e.target.value)
     }} name="phone" placeholder="Enter phone number" required></Input>
     <Label>Email:</Label>
     <Input type="text" value={semail} onChange={(e)=>{
       setsemail(e.target.value)
     }} name="email" placeholder="Enter email" required></Input>
     
      <Label>Origin Country:</Label>
      <Select options={options} required value={OC} onChange={changeHandler} />
     
    
     
     <Label>origin address:</Label>
     <Input type="text" value={org} onChange={(e)=>{
       setorg(e.target.value)
     }} name="org" placeholder="Enter origin address" required></Input>
    
   
    
   </FormGroup>
   <FormGroup>
   <h1>RECEIVER DETAILS</h1>
   <Label>Reciever Name:</Label>
     <Input type="text" value={receiver} onChange={(e)=>{
       setreceiver(e.target.value)
     }} name="receiver" placeholder="Enter receiver name" required></Input>
     <Label>Phone:</Label>
     <Input type="text" value={phone} onChange={(e)=>{
       setphone(e.target.value)
     }} name="phone" placeholder="Enter phone number" required></Input>
     <Label>Email:</Label>
     <Input type="text" value={email} onChange={(e)=>{
       setemail(e.target.value)
     }} name="email" placeholder="Enter email" required></Input>
     <Label>destination country:</Label>
     <Select options={options} required value={dc} onChange={changeHandler2} />
     
      <Label>destination address:</Label>
     <Input type="text" value={dst} onChange={(e)=>{
       setdst(e.target.value)
     }} name="dst" placeholder="Enter destination address" required></Input>
     
     <Label>Current Location:</Label>
     <Select required options={options} value={cl} onChange={changeHandler3} />

     
   </FormGroup>
      
      </div>
      
   <div style={{display:'flex',justifyContent:'center',margin:'auto',gap:'10px'}}><Button type="submit" >Submit</Button>
      <Link to="/admindash104" className="btn btn-danger ml-2">Cancel</Link></div>
      
    </Form>
    </div>
  )
}
